import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Select} from "antd";
//local
import {Tag} from "components/Tag";
import {Info} from "components/Info";
import {dropdownStatusColors} from "constants/select.consts";
import {IconChevronDown} from "components/icons";
import {color} from "constants/color.consts";
import {hasValue} from "helpers/helper";
import cn from "classnames";

const StatusesSelect = ({
  list,
  label,
  uppercaseLabel,
  boldLabel,
  tinyLabel,
  prefixLabel,
  selectStatus,
  someStatuses,
  noStatus,
  multiple,
  itemColor,
  onChange,
  disabled,
  defaultValue,
  informationText,
  addClass,
}) => {
  const {t} = useTranslation();
  const {Option} = Select;

  const SelectLabel = () => (
    <label
      className={cn("mini-select_label", {
        __uppercase: !!uppercaseLabel,
        __bold: !!boldLabel,
        __tiny: !!tinyLabel,
        "ml-1": !prefixLabel,
        "mr-1": prefixLabel,
      })}
    >
      {t(label)}
    </label>
  );

  const [selected, setSelected] = useState(defaultValue);

  const options = () =>
    list?.map((status) => (
      <Option key={status} value={status}>
        <Tag
          text={status}
          color={itemColor || dropdownStatusColors[status]}
          suffixIcon={
            <IconChevronDown
              color={
                [selectStatus, noStatus].includes(status)
                  ? color[dropdownStatusColors[status]]
                  : color.white
              }
            />
          }
          noBackground={
            (multiple && !selected?.includes(status)) ||
            [selectStatus, noStatus].includes(status)
          }
          needTranslation
        />
      </Option>
    ));

  const tagRender = () => {
    const count = selected?.length === list?.length ? "" : selected?.length ?? "";
    return (
      <Tag
        text={`${count} ${t(count ? someStatuses : noStatus)}`}
        suffixIcon={<IconChevronDown color={color.black} />}
        color={color.black}
        noBackground
      />
    );
  };

  return (
    <div className={cn("procurement-statuses-select_wrapper", {[addClass]: !!addClass})}>
      {hasValue(label) && prefixLabel && <SelectLabel />}
      <Select
        className="procurement-statuses_select"
        bordered={false}
        tagRender={multiple ? tagRender : undefined}
        placeholder={
          multiple ? (
            <Tag
              text={noStatus}
              suffixIcon={<IconChevronDown color={color.black} />}
              color={color.black}
              noBackground
              needTranslation
            />
          ) : undefined
        }
        showSearch={false}
        maxTagCount={1}
        onChange={(value) => {
          onChange(value);
          setSelected(value);
        }}
        mode={multiple ? "multiple" : undefined}
        suffixIcon={null}
        defaultValue={defaultValue}
        value={selected}
        disabled={disabled}
        popupClassName="procurement-statuses_dropdown"
      >
        {options()}
      </Select>
      {hasValue(label) && !prefixLabel && <SelectLabel />}
      {informationText && (
        <Info
          tooltip={informationText}
          centerText
          addClass={label && !prefixLabel ? "ml-2" : "ml-1"}
        />
      )}
    </div>
  );
};

export default StatusesSelect;
